import script from "./AllBusinessesForSupplierForecast.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllBusinessesForSupplierForecast.vue?vue&type=script&setup=true&lang=ts"

import "./AllBusinessesForSupplierForecast.vue?vue&type=style&index=0&id=3589a954&lang=scss&scoped=true"
import "./AllBusinessesForSupplierForecast.vue?vue&type=style&index=1&id=3589a954&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3589a954"]])

export default __exports__